import React from "react";
import { max } from "d3-array";
import { scaleLinear } from "d3-scale";

import Localization from "../Localization";
import { formatAs } from "../settings.js";

const height = 96;
const yScale = scaleLinear().range([0, height]);

export default function CapacityTooltip(props) {
  const { name, years } = props.data;

  const width = 19.2 * years.length;
  const maxCapacity = max(years.map((y) => y.total));
  yScale.domain([0, maxCapacity]).nice();

  return (
    <div className="tooltip capacityTooltip" style={{ minWidth: width + 64 }}>
      <div className="tooltipTitle">
        {Localization.getLanguage() === "zh"
          ? Localization.get(name.toUpperCase())
          : name}
      </div>
      <div className="content">
        <div
          className="yAxis"
          style={{ height: Math.round(yScale(maxCapacity)) }}
        >
          {yScale.ticks(4).map((t) => {
            return t <= maxCapacity ? (
              <div
                key={t}
                className="tick"
                style={{ bottom: Math.round(yScale(t)) }}
              >
                <div className="text">
                  {formatAs.numberInt(t)} {t === 0 ? "MW" : null}
                </div>
                <div className="line" style={{ width }} />
              </div>
            ) : null;
          })}
        </div>
        <div className="bars" style={{ width }}>
          {years.map((y, i) => {
            return (
              <div key={y.year} className="year">
                <div
                  className="bar"
                  style={{ height: Math.round(yScale(y.total)) }}
                />
                <div className="label">
                  <div className="text">{y.year}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
